export default __webpack_public_path__ + "static/thumbnailBg-6ae6b817ef95e0e2ca3acff39427ff41.png";